import { ActionFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { parseFormData } from "../../utils/parseFormData";

export const userAction: ActionFunction = async ({ request, params }) => {
  const formData = await request.formData();
  const action = formData.get("action");
  const updates = parseFormData(formData, {
    booleans: ["emailConfirmed", "isGraduationVerified", "phoneNumberConfirmed"],
    numbers: ["totalParticipation"],
  });
  // Kilitleme
  if (action === "lock") {
    await axiosApi.put(`api/users/${params.id}/lock`);
    return redirect(`/users/${params.id}`);
  }
  // Kilit Kaldırma
  if (action === "unlock") {
    await axiosApi.put(`api/users/${params.id}/unlock`);
    return redirect(`/users/${params.id}`);
  }
  // Kilit Kaldırma
  if (action === "remove-all-messages") {
    await axiosApi.delete(`api/chats/${params.id}/remove-all-messages`);
    return redirect(`/users/${params.id}`);
  }

  if (action === "save") {
    if (params.id === "new") await axiosApi.post("/api/users", updates);
    else await axiosApi.put("/api/users", { ...updates, id: params.id });
    return redirect(`/users`);
  }
};
